export default __webpack_public_path__ + "static/media/jsx-logo.e522a746.png";